<template>
  <el-table :data="tableList" border>
    <template v-for="item in tableHead">
      <el-table-column
        :key="item.No"
        :prop="item.columnName"
        :label="item.columnComment"
        :width="item.width"
        header-align="center"
        :align="item.align || 'center'">
      </el-table-column>
    </template>
  </el-table>
</template>

<script>
export default {
  data() {
    return {
      tableHead: [],
      tableList: []
    };
  },
  created() {
    this.tableHead = [
      { columnName: 'No', columnComment: this.$t('LogisticsRulesTable.header.No'), width: 50 },
      { columnName: 'Logistics', columnComment: this.$t('LogisticsRulesTable.header.Logistics'), width: 160 },
      { columnName: 'Code', columnComment: this.$t('LogisticsRulesTable.header.Code'), width: 80 },
      { columnName: 'FuelLevy', columnComment: this.$t('LogisticsRulesTable.header.FuelLevy'), width: 120 },
      { columnName: 'OversizedSurcharge', columnComment: this.$t('LogisticsRulesTable.header.OversizedSurcharge'), align: 'left' },
      { columnName: 'OverweightSurcharge', columnComment: this.$t('LogisticsRulesTable.header.OverweightSurcharge'), align: 'left' },
      { columnName: 'OtherSpecialRules', columnComment: this.$t('LogisticsRulesTable.header.OtherSpecialRules'), width: 190, align: 'left' },
      { columnName: 'GST', columnComment: 'GST', width: 60 },
      { columnName: 'UpdateDate', columnComment: this.$t('LogisticsRulesTable.header.UpdateDate'), width: 110 },
    ];
    this.tableList = [
      { No: '1', Logistics: 'Aupost Standard', Code: 'AUSP', FuelLevy: '5%', OversizedSurcharge: this.$t('LogisticsRulesTable.OversizedSurchargeCol.auS'), OverweightSurcharge: this.$t('LogisticsRulesTable.OverweightSurchargeCol.auS'), OtherSpecialRules: '', GST: '10%', UpdateDate: '2025/03/25' },
      { No: '2', Logistics: 'Aupost Express', Code: 'AUSX', FuelLevy: '5%', OversizedSurcharge: this.$t('LogisticsRulesTable.OversizedSurchargeCol.auE'), OverweightSurcharge: this.$t('LogisticsRulesTable.OverweightSurchargeCol.auE'), OtherSpecialRules: '', GST: '10%', UpdateDate: '2025/03/25' },
      { No: '3', Logistics: 'Aupost International', Code: 'AUSI', FuelLevy: '5%', OversizedSurcharge: this.$t('LogisticsRulesTable.OversizedSurchargeCol.auI'), OverweightSurcharge: this.$t('LogisticsRulesTable.OverweightSurchargeCol.auI'), OtherSpecialRules: this.$t('LogisticsRulesTable.OtherSpecialRulesCol.auI'), GST: '10%', UpdateDate: '2025/03/25' },
      { No: '4', Logistics: 'AlliedExpress', Code: 'ALLI', FuelLevy: '26.9%', OversizedSurcharge: this.$t('LogisticsRulesTable.OversizedSurchargeCol.alE'), OverweightSurcharge: this.$t('LogisticsRulesTable.OverweightSurchargeCol.alE'), OtherSpecialRules: '', GST: '10%', UpdateDate: '2025/03/25' },
      { No: '5', Logistics: 'CourierPlease', Code: 'COPL', FuelLevy: 'Not Provided', OversizedSurcharge: this.$t('LogisticsRulesTable.OversizedSurchargeCol.coP'), OverweightSurcharge: this.$t('LogisticsRulesTable.OverweightSurchargeCol.coP'), OtherSpecialRules: '', GST: '10%', UpdateDate: '2025/03/25' },
      { No: '6', Logistics: 'DirectFreight', Code: 'DIFE', FuelLevy: '19.6%', OversizedSurcharge: this.$t('LogisticsRulesTable.OversizedSurchargeCol.diF'), OverweightSurcharge: this.$t('LogisticsRulesTable.OverweightSurchargeCol.diF'), OtherSpecialRules: '', GST: '10%', UpdateDate: '2025/03/25' },
      { No: '7', Logistics: 'Fastway/Aramex', Code: 'FWAY', FuelLevy: '7.6%', OversizedSurcharge: this.$t('LogisticsRulesTable.OversizedSurchargeCol.faA'), OverweightSurcharge: this.$t('LogisticsRulesTable.OverweightSurchargeCol.faA'), OtherSpecialRules: '', GST: '10%', UpdateDate: '2025/03/25' },
      { No: '8', Logistics: 'HunterExpress', Code: 'HUNT', FuelLevy: '21%', OversizedSurcharge: this.$t('LogisticsRulesTable.OversizedSurchargeCol.huE'), OverweightSurcharge: this.$t('LogisticsRulesTable.OverweightSurchargeCol.huE'), OtherSpecialRules: this.$t('LogisticsRulesTable.OtherSpecialRulesCol.huE'), GST: '10%', UpdateDate: '2025/03/25' },
    ];
  }
};
</script>

<style scoped>
</style>
